import { useEffect } from "react";

const ProtectedRoute = ({ children, permissionName, setTrialEndOpen }) => {
    let currentSubscription = JSON.parse(localStorage.getItem("subscription"));
    // let currentTrial = JSON.parse(localStorage.getItem("trial"));
    const org = JSON.parse(localStorage.getItem("org"));
  
    const permissions = currentSubscription?.plan?.permission || [];
  
    const hasPermission = permissions.some(
      (permission) =>
        permission.key === permissionName && permission.isPermission
    );

    
  // const accessAllowed = hasPermission && currentTrial !== false;
  
 useEffect(() => {
    if (!hasPermission) {
      // setTrialEndOpen(true);
    }
  }, [hasPermission, setTrialEndOpen]);

  return children;
};

  export default ProtectedRoute;
  